import React, { useContext, useEffect } from 'react';
import { WizardContext } from '../../context';
import { ButtonParamType, DefaultButtonStyle } from '../button/revamp-button';
import ButtonGroup, { ButtonConfig, LayoutType } from '../button-group/revamp-button-group';
import './simple-wizard.scss';

export type Page = React.ReactFragment;

export type SimpleWizardPageProps = {
  navigateToNextStep: () => void;
  navigateToPreviousStep: () => void;
  brokerLogin?: boolean;
  automationIdSuffix?: string;
};

export type SimpleWizardPageStep = {
  page: (props: SimpleWizardPageProps) => Page;
};

export type SimpleWizardProps = {
  steps: SimpleWizardPageStep[];
  currentStepIndex: number;
  navigateToNextStep: () => void;
  navigateToPreviousStep: () => void;
  automationIdPrefix: string;
  brokerLogin?: string;
};

export function SimpleWizard({
  steps,
  currentStepIndex,
  navigateToNextStep,
  navigateToPreviousStep,
  brokerLogin,
}: SimpleWizardProps) {
  const {
    setOnNextEventHandler,
    setOnBackEventHandler,
    handleNavigateNext,
    handleNavigateBack,
    backButtonEnabled,
    nextButtonEnabled,
    nextButtonLabel,
    backButtonLabel,
    nextButtonVisible,
    backButtonVisible,
  } = useContext(WizardContext);

  useEffect(() => {
    setOnNextEventHandler(navigateToNextStep);
    setOnBackEventHandler(navigateToPreviousStep);
  }, [currentStepIndex]);

  const currentStep = steps[currentStepIndex];

  const buildModalButtons = () => {
    const buttonConfigs: ButtonConfig[] = [];


    if (backButtonVisible && currentStepIndex > 0) {
      buttonConfigs.push({
        automationId: `Revamp_Order_Summary_Delivery_${backButtonLabel}_Button`,
        label: backButtonLabel,
        buttonStyle: DefaultButtonStyle().hasSecondaryAction().isMediumSize().build(),
        className: 'modal-button',
        buttonParams: {
          type: ButtonParamType.NormalButton,
          onClick: handleNavigateBack,
          disabled: !backButtonEnabled,
        },
      });
    }

    if (nextButtonVisible) {
      buttonConfigs.push({
        automationId: `Revamp_Order_Summary_Delivery_${nextButtonLabel}_Button`,
        label: brokerLogin ? 'Next' : nextButtonLabel,
        buttonStyle: DefaultButtonStyle().hasModalPrimary().isMediumSize().hasLightMode().build(),
        className: 'modal-button',
        buttonParams: {
          type: ButtonParamType.NormalButton,
          onClick: handleNavigateNext,
          disabled: !nextButtonEnabled,
        },
      });
    }

    return <ButtonGroup buttons={buttonConfigs} layoutType={LayoutType.CENTERED} />;
  };

  return (
    <article className="SimpleWizard">
      <section className="form-section">
        {currentStep.page({ navigateToNextStep, navigateToPreviousStep })}
      </section>

      <section className="button-section">{buildModalButtons()}</section>
    </article>
  );
}
